import { render, staticRenderFns } from "./RoomObject.vue?vue&type=template&id=8980d81c&scoped=true&"
import script from "./RoomObject.vue?vue&type=script&lang=js&"
export * from "./RoomObject.vue?vue&type=script&lang=js&"
import style0 from "./RoomObject.vue?vue&type=style&index=0&id=8980d81c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8980d81c",
  null
  
)

component.options.__file = "RoomObject.vue"
export default component.exports